var spacing = {
    1: "4px",
    2: "8px",
    3: "12px",
    4: "16px",
    5: "24px",
    6: "32px",
    7: "40px",
    8: "48px",
    9: "64px",
    10: "96px"
};

export { spacing as default };
//# sourceMappingURL=spacing.js.map
